import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    text: {
      primary: "#616161",
    },
    primary: {
      main: "#008080",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
          gap: theme.spacing(1),
          borderRadius: theme.spacing(1),
          "& .MuiTypography-root": {
            color: ownerState.disabled
              ? theme.palette.action.disabled
              : ownerState.variant === "contained"
                ? theme.palette.primary.contrastText
                : theme.palette.primary.main,
          },
          "& .button-label": {
            fontWeight: 600,
            textTransform: "none",
            textAlign: "center",
          },
          "& .button-subtext": {
            fontSize: "0.875rem",
            textAlign: "center",
            textTransform: "none",
            color: ownerState.disabled
              ? theme.palette.action.disabled
              : ownerState.variant === "contained"
                ? theme.palette.primary.contrastText
                : theme.palette.text.secondary,
          },
          "& .MuiSvgIcon-root": {
            fontSize: "48px",
            color: ownerState.disabled ? theme.palette.action.disabled : "inherit",
          },
        }),
      },
    },
  },
});

export default theme;
